import { Middleware } from 'swr'

const addsLoading: Middleware = (useSWRNext) => (key, fetcher, config) => {
  const swr = useSWRNext(key, fetcher, config)

  return { ...swr, loading: swr.isLoading }
}

export default addsLoading
